module.exports = __webpack_public_path__ + "static/img/NSW-12.491f6bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-12.jpg
// module id = lJQY
// module chunks = 0